const META_PREFIX = 'meta.';
const DEFAULT_OPERATOR = 'eq';
const DEFAULT_TYPE = 'string';

export interface MetaFilterItem {
  key: string;
  value: string;
  type?: string;
  operator?: string;
}

export const EMPTY_META: MetaFilterItem = {
  key: '',
  value: '',
  type: undefined,
  operator: undefined,
};

const isMetaKey = (key: string): boolean => key.startsWith(META_PREFIX);

const serializeMetaKey = ({ key, operator, type }: MetaFilterItem): string => (
  `${META_PREFIX}${key}__${operator ?? DEFAULT_OPERATOR}:${type ?? DEFAULT_TYPE}`
);

export const parseMetaFilters = (filters: Record<string, unknown>): MetaFilterItem[] => {
  const items: MetaFilterItem[] = [];

  Object.entries(filters).forEach(([paramKey, value]) => {
    if (!isMetaKey(paramKey) || value === undefined) return;

    const body = paramKey.slice(META_PREFIX.length);
    const colon = body.lastIndexOf(':');
    const underscore = body.lastIndexOf('__');
    if (colon === -1 || underscore === -1 || underscore > colon) return;

    items.push({
      key: body.slice(0, underscore),
      operator: body.slice(underscore + 2, colon),
      type: body.slice(colon + 1),
      value: String(value),
    });
  });

  return items;
};

export const applyMetaFilters = (
  filters: Record<string, unknown>,
  rows: MetaFilterItem[],
): Record<string, unknown> => {
  const next: Record<string, unknown> = {};

  Object.entries(filters).forEach(([paramKey, value]) => {
    if (!isMetaKey(paramKey)) next[paramKey] = value;
  });

  rows.forEach((row) => {
    if (row.key && row.value) next[serializeMetaKey(row)] = row.value;
  });

  return next;
};
